import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { mergeMap, shareReplay, tap } from 'rxjs/operators'
import { BehaviorSubject, Observable } from 'rxjs';
import { LoggedUser } from '../shared/interfaces/interfaces';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private authUserSource = new BehaviorSubject<any>(null);
  authUser$ = this.authUserSource.asObservable();
  private isAuthenticatedCache$: Observable<any> | null = null;

  constructor(private httpClient: HttpClient) { }

  public isAuthenticated(): Observable<LoggedUser[]> {
    if (this.isAuthenticatedCache$) {
      return this.isAuthenticatedCache$;
    }

    const uuid = localStorage.getItem('uuid');
    const email = localStorage.getItem('email');

    this.isAuthenticatedCache$ = this.httpClient.get<any>('assets/env_specific/config.json').pipe(
      mergeMap(config => {
        return this.httpClient.post<LoggedUser[]>(`${config['API']}/users/isAuthenticate`, { token: uuid, email: email })
      }),
      tap((res: any) => {
        this.authUserSource.next(res[0]);
      }),
      shareReplay(1)
    )

    return this.isAuthenticatedCache$;
  }

  login(loginData: { email: string, password: string }) {
    this.clearCache(); 

    return this.httpClient.get<any>('assets/env_specific/config.json').pipe(
      mergeMap(config => {
        return this.httpClient.post<LoggedUser>(`${config['API']}/users/login`, loginData)
      }),
      tap((res: any) => {
        this.authUserSource.next(res);
        this.clearCache(); 
      })
    )
  }

  logout() {
    this.clearCache(); 
    this.authUserSource.next(null);
    localStorage.removeItem('uuid');
    localStorage.removeItem('email');
  }

  
  private clearCache(): void {
    this.isAuthenticatedCache$ = null;
  }

  get currentUser() {
    return this.authUserSource.getValue();
  }
}

// import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
// import { mergeMap } from 'rxjs/operators'
// import { BehaviorSubject, tap } from 'rxjs';
// import { LoggedUser } from '../shared/interfaces/interfaces';


// @Injectable({
//   providedIn: 'root'
// })
// export class AuthService {
//   private authUserSource = new BehaviorSubject<any>(null);
//   authUser$ = this.authUserSource.asObservable();
//   constructor(private httpClient: HttpClient) { }

//   public isAuthenticated() {
//     const uuid = localStorage.getItem('uuid');
//     const email = localStorage.getItem('email');

//     return this.httpClient.get<any>('assets/env_specific/config.json').pipe(
//       mergeMap(config => {
//         // return of(true)
//         return this.httpClient.post<LoggedUser[]>(`${config['API']}/users/isAuthenticate`, { token: uuid, email: email })
//       }),
//       tap((res: any) => {
//         // Φύλαξε τον χρήστη σε BehaviorSubject για μελλοντική χρήση
//         this.authUserSource.next(res[0]);
//       })
//     )
//   }

//   login(loginData: {email: string, password: string}) {

//     return this.httpClient.get<any>('assets/env_specific/config.json').pipe(
//       mergeMap(config => {
//         // return of(loginData)
//         return this.httpClient.post<LoggedUser>(`${config['API']}/users/login`, loginData)
//       })
//     )
//   }
//   get currentUser() {
//     return this.authUserSource.getValue();
//   }

// }
